import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

interface DealTierDescriptionEntityParams {
  product_id: number | string;
  deal_tier_id: number | string;
  distributor_id: number | string;
  product_group_id: string;
  sku: string;
}
export class DealTierDescriptionEntity extends BaseEntityClass {
  product_id: number | string;
  deal_tier_id: number | string;
  distributor_id: number | string;
  product_group_id: string;
  sku: string;
  constructor(params: DealTierDescriptionEntityParams) {
    super();
    this.type = "deal_tier_description";
    this.entity_version = 3;
    this.product_id = params.product_id;
    this.deal_tier_id = params.deal_tier_id;
    this.distributor_id = params.distributor_id;
    this.product_group_id = params.product_group_id;
    this.sku = params.sku;
  }
}
